import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js";

export default class extends Controller {
  static values = {
    appendToParent: Boolean,
    content: String,
    dangerouslyAllowHtml: { type: Boolean, default: false },
    hideArrow: Boolean,
    placement: { type: String, default: "top" },
    templateId: String
  }

  connect() {
    const settings = {
      allowHTML: this.dangerouslyAllowHtmlValue,
      appendTo: this.appendToParentValue ? "parent" : document.body,
      arrow: this.hideArrowValue ? false : true,
      content: this.contentValue,
      placement: this.placementValue
    }

    if (this.templateIdValue) {
      settings['arrow'] = false
      settings['appendTo'] = document.body,
      settings['content'] = document.getElementById(this.templateIdValue).innerHTML
      settings['interactive'] =  true
      settings['theme'] = 'html'
    }

    tippy(this.element, settings)
  }
}
